export default __webpack_public_path__ + "static/media/nonet.9ee693b6.webp";